'use client';

import React from 'react';
import Frame1 from '@/assets/images/home_feature_frame_1.png';
import Frame2 from '@/assets/images/home_feature_frame_2.png';
import Frame3 from '@/assets/images/home_feature_frame_3.png';
import Frame4 from '@/assets/images/home_feature_frame_4.png';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import CheckedBlue from '../icons/Checked.blue';

const Dot = () => {
  return (
    <div className="h-[20px] mt-[2px] w-fit flex items-center justify-center">
      <CheckedBlue />
    </div>
  );
};

export default function KeyFeatures() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();
  return (
    <div className="w-full h-fit bg-gray-50 py-[120px] flex flex-col items-center justify-center">
      <div className="w-fit flex flex-col items-start justify-center gap-[80px]">
        <div className="flex flex-col items-start justify-center">
          <div className="font-display font-semibold text-xl leading-3xl text-cic-blue-500">
            {t('home.key_features.title', {})}
          </div>
          <div className="mt-l font-display font-semibold text-4xl leading-18xl text-primary tracking-[0%]">
            {t('home.key_features.description', {})}
            <br />
            {t('home.key_features.description2', {})}
          </div>
          <div className="mt-4xl font-regular text-xl leading-3xl text-gray-600">
            {t('home.key_features.description3', {})}
            <br />
            {t('home.key_features.description4', {})}
          </div>
        </div>


        <div className="flex flex-col items-center justify-center gap-[24px] w-fit">
          <div className="flex flex-row items-center justify-center gap-[36px]">
            <div className="w-[622px] h-[620px] bg-white rounded-xl  shadow-[0_4px_6px_-2px_rgba(26,32,34,0.03),0_12px_16px_-4px_rgba(26,32,34,0.08)] p-s flex flex-col justify-start items-start">
              <img src={Frame1.src} alt="" className="w-full rounded-[10px]" />
              <div className="p-5xl font-display flex flex-col items-start justify-start gap-[20px]">
                <div className="font-semibold text-2xl leading-4xl text-primary">
                  {t('home.key_features.flexible_gpu_scheduling', {})}
                </div>
                <ul className="blue-dot-list text-gray-600 space-y-[8px]">
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.flexible_gpu_scheduling.description',
                        {}
                      )}
                    </span>
                  </li>
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.flexible_gpu_scheduling.description2',
                        {}
                      )}
                      <br />
                      {t(
                        'home.key_features.flexible_gpu_scheduling.description3',
                        {}
                      )}
                    </span>
                  </li>
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.flexible_gpu_scheduling.description4',
                        {}
                      )}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="w-[622px] h-[620px] bg-white rounded-xl shadow-[0_4px_6px_-2px_rgba(26,32,34,0.03),0_12px_16px_-4px_rgba(26,32,34,0.08)] p-s flex flex-col justify-start items-start">
              <img src={Frame2.src} alt="" className="w-full rounded-[10px]" />
              <div className="p-5xl font-display flex flex-col items-start justify-start gap-[20px]">
                <div className="font-semibold text-2xl leading-4xl text-primary">
                  {t('home.key_features.high_performance_parallel_storage', {})}
                </div>
                <ul className="blue-dot-list text-gray-600 space-y-[8px]">
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.high_performance_parallel_storage.description',
                        {}
                      )}
                      <br />{' '}
                      {t(
                        'home.key_features.high_performance_parallel_storage.description2',
                        {}
                      )}
                    </span>
                  </li>
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.high_performance_parallel_storage.description3',
                        {}
                      )}
                      <br />
                      {t(
                        'home.key_features.high_performance_parallel_storage.description4',
                        {}
                      )}
                    </span>
                  </li>
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.high_performance_parallel_storage.description5',
                        {}
                      )}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="flex flex-row items-center justify-center gap-[36px]">
            <div className="w-[622px] h-[620px] bg-white rounded-xl shadow-[0_4px_6px_-2px_rgba(26,32,34,0.03),0_12px_16px_-4px_rgba(26,32,34,0.08)] p-s flex flex-col justify-start items-start">
              <img src={Frame3.src} alt="" className="w-full rounded-[10px]" />
              <div className="p-5xl font-display flex flex-col items-start justify-start gap-[20px]">
                <div className="font-semibold text-2xl leading-4xl text-primary">
                  {t('home.key_features.usage_based_resource_management', {})}
                </div>
                <ul className="blue-dot-list text-gray-600 space-y-[8px]">
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.usage_based_resource_management.description',
                        {}
                      )}
                    </span>
                  </li>
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.usage_based_resource_management.description2',
                        {}
                      )}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="w-[622px] h-[620px] bg-white rounded-xl shadow-[0_4px_6px_-2px_rgba(26,32,34,0.03),0_12px_16px_-4px_rgba(26,32,34,0.08)] p-s flex flex-col justify-start items-start">
              <img src={Frame4.src} alt="" className="w-full rounded-[10px]" />
              <div className="p-5xl font-display flex flex-col items-start justify-start gap-[20px]">
                <div className="font-semibold text-2xl leading-4xl text-primary">
                  {t('home.key_features.integrated_performance_monitoring', {})}
                </div>
                <ul className="blue-dot-list text-gray-600 space-y-[8px]">
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.integrated_performance_monitoring.description',
                        {}
                      )}
                      <br />
                      {t(
                        'home.key_features.integrated_performance_monitoring.description2',
                        {}
                      )}
                    </span>
                  </li>
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.integrated_performance_monitoring.description3',
                        {}
                      )}
                    </span>
                  </li>
                  <li className="flex flex-row justify-start items-start gap-[8px]">
                    <Dot />
                    <span className="font-regular text-md leading-xl">
                      {t(
                        'home.key_features.integrated_performance_monitoring.description4',
                        {}
                      )}
                      <br />
                      {t(
                        'home.key_features.integrated_performance_monitoring.description5',
                        {}
                      )}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
